import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolClientAction } from '../symbolClient.action';
import { SymbolClientTranslator } from '../symbolClient.translator';

type IDependencies = IClientApiDependencySegment;

export const createSymbolClientEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolClientAction.create.started),
  mergeMap((params) => {
    const { nodeId, reject } = params;

    return dependencies.api.createClientSymbol({ nodeId, ...SymbolClientTranslator.toApi(params) }).pipe(
      mergeMap(() => {
        return [
          SymbolClientAction.create.done({ params }),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          SymbolClientAction.create.failed({ params, error }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
